export default function ModuleTitle({ data }) {
  const { title } = data;

  return (
    <>
      <div className="text-center p-4 pt-6">
        <h2 className="text-4xl -mb-1">{title}</h2>

        <div className="inline-block w-4rem border-bottom-2 border-red-600"></div>
      </div>
    </>
  );
}
